import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_up",
  "use": "icon-arrow_up-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-arrow_up\">\n<g>\n\t<g>\n\t\t<path d=\"M9.8,4.3L9.8,4.3C9.5,4.3,9.2,4.4,9,4.6l-8.2,8.9c-0.4,0.4-0.4,1.1,0.1,1.5S2,15.5,2.4,15l7.4-8.1l7.8,8.5\n\t\t\tc0.4,0.4,1.1,0.5,1.5,0.1c0.4-0.4,0.5-1.1,0.1-1.5l-8.6-9.3C10.4,4.4,10.1,4.3,9.8,4.3z\" />\n\t</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol